<div class="container-box">
  <h1> Page Not Found </h1>
  <div class="alert valign-children-middle">
    <div class="alert-error" aria-label="Error.">
      <i class="icon-badgealert" aria-hidden="true"></i>
    </div>
    <div>
      <h3> We can't seem to find the page you're looking for. </h3>
      <a *ngIf="!isAdmin" routerLink="/home">Return to landing page.</a>
      <a *ngIf="isAdmin" routerLink="/care/home">Return to landing page.</a>
    </div>
  </div>
</div>